import apiClient from "../../apiClient";
import { Agent, GetAgentsResponse } from "./type";

class AgentsService {
  async getAgents(params?: {
    skip?: number;
    limit?: number;
    name?: string;
  }): Promise<GetAgentsResponse> {
    const response = await apiClient.get(`agents`, { params });
    return response.data;
  }

  async getAgentById(id: string): Promise<Agent> {
    const response = await apiClient.get(`agents/${id}`);
    return response.data;
  }
}

export const agentsService = new AgentsService();
